export var EChild = /*#__PURE__*/function (EChild) {
  EChild["Header"] = "Header";
  EChild["Inputs"] = "Inputs";
  EChild["Payments"] = "Payments";
  EChild["Button"] = "Button";
  EChild["Bonus"] = "Bonus";
  EChild["Result"] = "Result";
  return EChild;
}({});
export var EStep = /*#__PURE__*/function (EStep) {
  EStep[EStep["Input"] = 0] = "Input";
  EStep[EStep["PaymentType"] = 1] = "PaymentType";
  return EStep;
}({});
export var COPYRIGHT = 'платёжный виджет © {{year}}';